import React from 'react';
import "./comment.css";
import CommentForm from './components/commentForm';
import CommentList from './components/commentList';

const Comment = ({user, blogId, blog, setBlog}) => {

    return (
        <section className="comment section">
            <div className='comment-container padd-15'>
                <div className="row">
                    <CommentForm 
                        user = {user}
                        blogId = {blogId}
                        blog = {blog}
                        setBlog = {setBlog}
                    />
                </div>
                <h3 className='title'>Comments ({blog.comments?.length})</h3>
                <div className="row">
                    <CommentList 
                        user = {user}
                        blogId = {blogId}
                        blog = {blog}
                        setBlog = {setBlog}
                    />
                </div>
            </div>
        </section>
    );
}

export default Comment;